export default __webpack_public_path__ + "static/media/sky.e745cc5d.png";